import Big from 'big.js'
import { Measure } from '../types'

enum LengthMeasurementSystem {
  metric = 'Metric Units',
  imperial = 'Imperial Units',
  nautical = 'Nautical Units'
}


const lengthUnits = {
  nanometer: {
    displayName: 'Nanometer',
    codeName: 'nanometer',
    url: 'nanometer',
    symbol: 'nm',
    toBaseUnit: (value: Big) => value.div(1000000000),
    fromBaseUnit: (value: Big) => value.times(1000000000),
    system: LengthMeasurementSystem.metric
  },
  micrometer: {
    displayName: 'Micrometer',
    codeName: 'micrometer',
    url: 'micrometer',
    symbol: 'μm',
    toBaseUnit: (value: Big) => value.div(1000000),
    fromBaseUnit: (value: Big) => value.times(1000000),
    system: LengthMeasurementSystem.metric
  },
  millimeter: {
    displayName: 'Millimeter',
    codeName: 'millimeter',
    url: 'millimeter',
    symbol: 'mm',
    toBaseUnit: (value: Big) => value.div(1000),
    fromBaseUnit: (value: Big) => value.times(1000),
    system: LengthMeasurementSystem.metric
  },
  centimeter: {
    displayName: 'Centimeter',
    codeName: 'centimeter',
    url: 'centimeter',
    symbol: 'cm',
    toBaseUnit: (value: Big) => value.div(100),
    fromBaseUnit: (value: Big) => value.times(100),
    system: LengthMeasurementSystem.metric
  },
  meter: {
    displayName: 'Meter',
    codeName: 'meter',
    url: 'meter',
    symbol: 'm',
    toBaseUnit: (value: Big) => value,
    fromBaseUnit: (value: Big) => value,
    system: LengthMeasurementSystem.metric
  },
  kilometer: {
    displayName: 'Kilometer',
    codeName: 'kilometer',
    url: 'kilometer',
    symbol: 'km',
    toBaseUnit: (value: Big) => value.times(1000),
    fromBaseUnit: (value: Big) => value.div(1000),
    system: LengthMeasurementSystem.metric
  },

  inch: {
    displayName: 'Inch',
    codeName: 'inch',
    url: 'inch',
    symbol: 'in',
    toBaseUnit: (value: Big) => value.times(0.0254),
    fromBaseUnit: (value: Big) => value.div(0.0254),
    system: LengthMeasurementSystem.imperial
  },
  foot: {
    displayName: 'Foot',
    codeName: 'foot',
    url: 'foot',
    symbol: 'ft',
    toBaseUnit: (value: Big) => value.times(0.3048),
    fromBaseUnit: (value: Big) => value.div(0.3048),
    system: LengthMeasurementSystem.imperial
  },
  yard: {
    displayName: 'Yard',
    codeName: 'yard',
    url: 'yard',
    symbol: 'yd',
    toBaseUnit: (value: Big) => value.times(0.9144),
    fromBaseUnit: (value: Big) => value.div(0.9144),
    system: LengthMeasurementSystem.imperial
  },
  mile: {
    displayName: 'Mile',
    codeName: 'mile',
    url: 'mile',
    symbol: 'mi',
    toBaseUnit: (value: Big) => value.times(1609.344),
    fromBaseUnit: (value: Big) => value.div(1609.344),
    system: LengthMeasurementSystem.imperial
  },


  nautical_mile: {
    displayName: 'Nautical mile',
    codeName: 'nautical_mile',
    url: 'nautical-mile',
    symbol: 'NM',
    toBaseUnit: (value: Big) => value.times(1852),
    fromBaseUnit: (value: Big) => value.div(1852),
    system: LengthMeasurementSystem.nautical
  }
}

export const length: Measure = {
  displayName: 'Length',
  codeName: 'length',
  url: 'length',
  units: lengthUnits,
  baseUnit: lengthUnits.meter,
  defaultFromUnit: lengthUnits.mile,
  defaultToUnit: lengthUnits.kilometer
}
